/*
 * @Author: Zhouqi
 * @Date: 2026-01-09
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09 18:09:01
 */
import type { NextPage } from 'next';
import type { ReactElement, ReactNode } from 'react';

import Layout from '@/components/layout';

/**
 * 高阶函数，为页面组件添加 Layout
 * 使用 getLayout 模式，确保 Layout 在路由切换时不会重新挂载
 */
export function withLayout<P = {}>(page: NextPage<P>): NextPage<P> {
  const PageWithLayout = page as NextPage<P> & {
    getLayout?: (page: ReactElement) => ReactNode;
  };

  PageWithLayout.getLayout = (pageElement: ReactElement) => {
    return <Layout>{pageElement}</Layout>;
  };

  return PageWithLayout;
}
